<script>
import VideoPlayer from '@/components/shared/VideoPlayer';

export default {
  name: 'SCORM2004VideoPlayer',
  extends: VideoPlayer,
  methods: {
    setStatus(s) {
      if (s === 'c') return 'completed';
      if (s === 'p') return 'passed';
      if (s === 'i') return 'in-progress';
      if (s === 'f') return 'failed';
      return s;
    },
    init() {
      this.loading = true;
      this.getVideoSource()
        .then(() => {
          this.getProgress()
            .then(() => {
              this.setup();
            });
        });
      window.onbeforeunload = () => {
        this.saveProgress();
        this.exitSession();
      };
    },
    getProgress() {
      // eslint-disable-next-line
      return please(window.opener)
        .call('handleScormMessage', '{ "messageType": "get_suspend_data" }')
        .then(d => {
          if (d) {
            const res = JSON.parse(d);
            if (res) {
              this.currentPart = {
                status: res.s,
                score: res.qs,
                videoPosition: res.vp,
                maxVideoPosition: res.mp,
                watchedUntilEnd: res.we,
                endOfVideo: res.ev,
              };
              this.currentTime = res.vp;
              this.timeInCourse = res.vp;
            } else {
              this.timeInCourse = 0;
            }
          }
        });
    },
    saveProgress() {
      const body = {
        c: this.syncguid,
        s: this.setStatus(this.currentPart.status),
        qs: this.currentPart.score,
        we: this.currentPart.watchedUntilEnd,
        ev: this.currentPart.endOfVideo,
        vp: this.currentPart.videoPosition,
        mp: this.currentPart.maxVideoPosition,
        ps: [],
      };
      const msg = {
        messageType: 'save_suspend_data',
        data: body,
        score: body.qs,
        seconds: body.vp,
      };
      // eslint-disable-next-line
      return please(window.opener)
        .call('handleScormMessage', JSON.stringify(msg));
    },
    complete() {
      this.saveProgress();
      const msg1 = {
        messageType: 'time',
        sessiontime: this.currentPart.timeInCourse,
      };
      const msg2 = {
        messageType: 'complete',
        sessiontime: this.currentPart.timeInCourse,
        hasQuiz: this.hasQuiz,
      };
      // eslint-disable-next-line
      please(window.opener)
        .call('handleScormMessage', JSON.stringify(msg1));
      // eslint-disable-next-line
      please(window.opener)
        .call('handleScormMessage', JSON.stringify(msg2));
    },
    exitSession() {
      // eslint-disable-next-line
      return please(window.opener)
        .call('handleScormMessage', '{ "messageType": "exit" }')
        .then(() => window.close());
    },
  },
  mounted() {
    this.init();
  },
};
</script>
